import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../utils/apiClient";

export default function MealPlanCookMode() {
  const { id } = useParams();
  const [mealPlan, setMealPlan] = useState(null);
  const [steps, setSteps] = useState([]);
  const [done, setDone] = useState([]);
  const [filter, setFilter] = useState("all");
  const [view, setView] = useState("grouped"); // "grouped" or "timeline"

  useEffect(() => {
    apiClient.get(`/mealplans/${id}`).then(res => {
      const plan = res.data;
      setMealPlan(plan);

          // time line
    const timelineSteps = [];
    const finishTime = new Date(); // now
    plan.recipes.forEach((recipe) => {
      const totalTime =
        parseTime(recipe.prepTime) + parseTime(recipe.cookTime);
      const stepCount = recipe.instructions.length || 1;
      const minsPerStep = totalTime / stepCount;
    
      recipe.instructions.slice().reverse().forEach((step, i) => {
        const offset = Math.round((i + 1) * minsPerStep);
        const time = new Date(finishTime.getTime() - offset * 60000);
    
        timelineSteps.push({
          time,
          recipe: recipe.name,
          step,
        });
      });
    });
    timelineSteps.sort((a, b) => a.time - b.time);
    setSteps(timelineSteps);
    //

      const combinedSteps = [];

      plan.recipes.forEach((recipe, recipeIndex) => {
        recipe.instructions.forEach((step, stepIndex) => {
          combinedSteps.push({
            recipeName: recipe.name,
            recipeId: recipe._id,
            step,
            key: `${recipeIndex}-${stepIndex}`,
          });
        });
      });

      setSteps(combinedSteps);
      setDone(Array(combinedSteps.length).fill(false));
    });
  }, [id]);


  

  const toggleDone = (index) => {
    setDone((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  //Time line

  const parseTime = (str) => {
    if (!str) return 0;
    const minMatch = str.match(/(\d+)\s*min/i);
    const hrMatch = str.match(/(\d+)\s*hour/i);
    const total =
      (hrMatch ? parseInt(hrMatch[1]) * 60 : 0) +
      (minMatch ? parseInt(minMatch[1]) : 0);
    return total;
  };

  //

  if (!mealPlan) return <p className="text-center mt-10">Loading Cook Mode...</p>;

  return (
    <div className="max-w-3xl mt-10 mx-auto px-4 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">{mealPlan.name} – Cook Mode</h1>
        {/*<button
          onClick={() => setView(view === "grouped" ? "timeline" : "grouped")}
          className="text-sm text-blue-500 hover:underline"
        >
          Switch to {view === "grouped" ? "Timeline" : "Grouped"} View
        </button>*/}
      </div>

      {/* Filter Buttons */}
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => setFilter("all")}
          className={`text-sm px-3 py-1 rounded ${filter === "all" ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-700"}`}
        >
          All Recipes
        </button>
        {mealPlan.recipes.map((r) => (
          <button
            key={r._id}
            onClick={() => setFilter(r._id)}
            className={`text-sm px-3 py-1 rounded ${filter === r._id ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-700"}`}
          >
            {r.name}
          </button>
        ))}
      </div>

      {/* Grouped Step View */}
      {view === "grouped" && (
        <div className="space-y-6">
          {mealPlan.recipes
            .filter((r) => filter === "all" || r._id === filter)
            .map((recipe) => (
              <div key={recipe._id} className="space-y-2">
                <h2 className="text-lg font-semibold border-b pb-1">{recipe.name}</h2>
                <ol className="space-y-3">
                  {recipe.instructions.map((step, idx) => {
                    const globalIndex = steps.findIndex(
                      (s) => s.recipeId === recipe._id && s.step === step
                    );
                    return (
                      <li
                        key={idx}
                        className={`border-l-4 pl-4 py-2 rounded ${
                          done[globalIndex] ? "border-green-500 bg-green-50" : "border-gray-300 bg-white"
                        }`}
                      >
                        <div className="flex justify-between items-center">
                          <p className="font-medium">Step {idx + 1}</p>
                          <button
                            onClick={() => toggleDone(globalIndex)}
                            className="text-xs text-blue-500 hover:underline"
                          >
                            {done[globalIndex] ? "Undo" : "Mark done"}
                          </button>
                        </div>
                        <p>{step}</p>
                      </li>
                    );
                  })}
                </ol>
              </div>
            ))}
        </div>
      )}

      {/* Timeline View Placeholder */}
        {view === "timeline" && (
        <div className="space-y-4">
            {steps.map((stepObj, i) => (
            <div key={i} className="border-l-4 pl-4 py-2 bg-white rounded shadow-sm">
                <div className="text-sm text-gray-500 mb-1">
                {console.log("Timeline step:", stepObj.step, "=>", stepObj.time)}
                {stepObj.time instanceof Date
            ? stepObj.time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            : "⏰"}
                </div>
                <div className="font-semibold text-sm">{stepObj.recipe}</div>
                <p className="text-sm">{stepObj.step}</p>
            </div>
            ))}
        </div>
        )}
    </div>
  );
}
